export default {
  setList: (state, list) => {
    state.list = [...state.list, ...list];
  },

  setDetail: (state, detail) => {
    state.detail = detail;
  },

  setPage: (state, page = 1) => {
    state.condition.page = page;
  },

  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },

  setStoreNos: (state, storeNos = []) => {
    state.condition.storeNos = storeNos;
  },

  purgeAll: (state) => {
    state.condition = {
      page: 1,
      limit: 10,
      totalPage: 2,
      storeNos: []
    };

    (state.pageInfo = {
      page: 1,
      totalPage: 2
    }),
      (state.list = []);
  }
};
